import React from 'react';
import { useSelector } from 'react-redux';
import './scss/style.scss';
import AppRoute, {
  AuthRoute
} from './routes/pageRouter';
import { isNotNull } from './utils/constants';
import MaintenanceGuard from './utils/hocs/MaintenanceGuard/MaintenanceGuard';

function App() {
  const token = useSelector((state) => state?.authReducer?.data?.token);
  return (
    <MaintenanceGuard>
      <div>
        {
          isNotNull(token) ?
            <AppRoute />
            :
            <AuthRoute />
        }
      </div>
    </MaintenanceGuard>
  )
};

export default App;
